import { useState } from 'react';

import type { AppointmentDetail } from '../api/types';
import { useProject } from '../projects/context';
import { confirmationOpen, phoneConfirmationView } from './phoneConfirmation';
import { PhoneConfirmationActions } from './PhoneConfirmationActions';

// Telefonische Terminbestätigung am Termin (OFFENE_FRAGEN B-29): Der Makler sieht den Stand, wer telefonieren darf (Support,
// Terminierer, Leitung), trägt hier auch das Ergebnis ein – nur vor Terminbeginn.
export function PhoneConfirmationCard({ appointment: a }: { appointment: AppointmentDetail }) {
  const { can } = useProject();
  const [now] = useState(() => new Date());
  const c = a.phone_confirmation;
  const view = c ? phoneConfirmationView(c, now) : null;
  if (!c || !view) return null;
  const actionable = confirmationOpen(c) && can('call.start') && new Date(a.start_at) > now;
  return (
    <section className="card phone-confirmation" aria-label="Telefonische Terminbestätigung">
      <div className="section-head">
        <h2>Telefonische Bestätigung</h2>
        <span className={`badge badge-${view.tone}`}>{view.label}</span>
      </div>
      <p>{view.text}</p>
      {c.note && <p className="muted">Hinweis: {c.note}</p>}
      {actionable && <PhoneConfirmationActions appointmentId={a.id} leadId={a.lead_id} leadName={a.lead_name ?? a.title} />}
    </section>
  );
}
